import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Icon, MaskField } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { getRoomsState } from 'src/store/rooms/selectors';
import { roomsActions } from 'src/store/rooms/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

const mask = {
  mask: 'HH:MM—HH:MM',
  blocks: {
    HH: {
      // @ts-expect-error global
      mask: IMask.MaskedRange,
      from: 0,
      to: 23,
      minLength: 2,
    },
    MM: {
      // @ts-expect-error global
      mask: IMask.MaskedRange,
      from: 0,
      to: 59,
      minLength: 2,
    },
  },
};

export const RoomBookingTimeField: FC = () => {
  const dispatch = useAppDispatch();
  const { backgroundData } = useSelector(getRoomsState);
  const { date, time, timeError } = useSelector(getRoomsState);

  const dateDisabled = !backgroundData;
  const timeDisabled = dateDisabled || !date;

  const setTime = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(roomsActions.setTime(event.target.value));
    },
    [dispatch],
  );

  return (
    <MaskField
      label='Время'
      startAdornment={<Icon iconName={Icons.Clock} />}
      maskConfig={mask}
      value={time}
      onInput={setTime}
      placeholder='чч:мм—чч:мм'
      error={!!timeError}
      helperText={timeError}
      disabled={timeDisabled}
      fullWidth
      dataTestId='roomBookingTime'
    />
  );
};
